// SPDX-License-Identifier: Apache-2.0
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerReadConn = exports.ErrErdstallContractNotConnected = exports.ErrUnsupportedLedgerEvent = void 0;
const ledger_1 = require("./..");
const contracts_1 = require("./contracts");
const ethwrapper_1 = require("./ethwrapper");
const axios_1 = __importDefault(require("axios"));
exports.ErrUnsupportedLedgerEvent = new Error("unsupported ledger event encountered");
exports.ErrErdstallContractNotConnected = new Error("erdstall contract not connected");
class LedgerReadConn {
    constructor(contract, tokenCache) {
        this.contract = contract;
        this.eventCache = new Map();
        this.metadataCache = new Map();
        this.tokenCache = tokenCache;
    }
    on(ev, cb) {
        const wcb = ethwrapper_1.ethCallbackShim(this.contract, this.tokenCache, ev, cb);
        this.eventCache.set(cb, wcb);
        this.contract.on(ev, wcb);
    }
    once(ev, cb) {
        this.contract.once(ev, ethwrapper_1.ethCallbackShim(this.contract, this.tokenCache, ev, cb));
    }
    off(ev, cb) {
        if (!this.eventCache.has(cb)) {
            return;
        }
        const wcb = this.eventCache.get(cb);
        this.contract.off(ev, wcb);
        this.eventCache.delete(cb);
    }
    removeAllListeners() {
        this.eventCache.clear();
        this.contract.removeAllListeners();
    }
    erdstall() {
        return ledger_1.Address.fromString(this.contract.address);
    }
    async getNftMetadata(token, id, useCache) {
        const tokenKey = token.key;
        if ((useCache == undefined || useCache) &&
            this.metadataCache.has(tokenKey)) {
            return this.metadataCache.get(tokenKey);
        }
        // TODO: Create IMetadata contract interface for which bindings can be
        // generated, so we have a single interface over which we can query
        // metadata for different contract implementations in the future.
        const metadataContract = contracts_1.IERC721Metadata__factory.connect(tokenKey, this.contract.provider);
        const tokenURI = await metadataContract.tokenURI(id);
        const res = await axios_1.default
            .get(tokenURI)
            .then((res) => res.data);
        this.metadataCache.set(tokenKey, res);
        return res;
    }
}
exports.LedgerReadConn = LedgerReadConn;
//# sourceMappingURL=readconn.js.map